import Client from './client';

export default class UserOneTimeTokens extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  post(options = {}) {
    return this.makeRequest(`${this.host}/users/tokens`, {
      ...options,
       method: 'POST',
    });
  }

  postRedeem(options = {}) {
    return this.makeRequest(`${this.host}/users/tokens/redeem`, {
      ...options,
       method: 'POST',
    });
  }

}
